export const advisorRequestQuestions = {
  topic: {
    question: 'Pick a topic',
    options: [
      {
        slug: 'budgeting' as const,
        title: 'Budgeting',
        icon: 'dollar_bill',
      },
      {
        slug: 'investing' as const,
        title: 'Investing',
        icon: 'trend_up',
      },
      {
        slug: 'debt_management' as const,
        title: 'Debt Management',
        icon: 'credit-cards-solid',
      },
      {
        slug: 'family_planning' as const,
        title: 'Family Planning',
        icon: 'child',
      },
      {
        slug: 'retirement' as const,
        title: 'Retirement',
        icon: 'palms',
      },
      {
        slug: 'insurance' as const,
        title: 'Insurance',
        icon: 'umbrella',
      },
      {
        slug: 'tax_and_estate' as const,
        title: 'Tax & Estate',
        icon: 'home_equity-solid',
      },
      {
        slug: 'other' as const,
        title: 'Other',
        icon: 'chat',
      },
    ],
  },
  notes: {
    question: 'Describe your situation and add questions',
  },
}

export type AdvisorTopics = (typeof advisorRequestQuestions)['topic']['options'][0]['slug']

export const topicsMap = advisorRequestQuestions.topic.options.reduce((acc, item) => {
  return {
    ...acc,
    [item.slug]: item.title,
  }
}, {} as Record<AdvisorTopics, string>)
